export default "__VITE_ASSET__77e72176__"